export default {"src":"/_next/static/media/credit-card.344502d3.svg","height":30,"width":32};